import { IAppStorage } from "./IAppStorage";


export class AppStorage implements IAppStorage {

    private _store: Storage;
    private _sessionStore: Storage;
    private _canStore: boolean;

    constructor() {
        //remap to local var
        this._store = localStorage;
        this._sessionStore = sessionStorage;
        this._canStore = (typeof (Storage) !== "undefined");
    }

    //set a storage value
    public setValue = (key: string, value: string): void => {
        if (this._canStore) {
            this._store[key] = value;
        }
    }

    public setSessionValue = (key: string, value: string): void => {
        if (this._canStore) {
            this._sessionStore[key] = value;
        }
    }

    //get a value by key from the store
    public getValue = (key: string): string => {
        if (this._canStore) {
            let val = this._store[key];
            return (typeof val === 'undefined') ? null : val;
        }
        return null;
    }

    //get a value by key from the store
    public getSessionValue = (key: string): string => {
        if (this._canStore) {
            let val = this._sessionStore[key];
            return (typeof val === 'undefined') ? null : val;
        }
        return null;
    }

    //get value from the store and parse it
    public getValueFromJson = (key: string, reviver?: (this: any, key: string, value: any) => any): object => {
        if (this._canStore) {
            if (this._store[key] !== null && typeof this._store[key] !== "undefined") {
                if (reviver) {
                    return JSON.parse(this._store[key], reviver);
                } else {
                    return JSON.parse(this._store[key]);
                }
            }
        }
        return null;
    }

    public getSessionValueFromJson = (key: string, reviver?: (this: any, key: string, value: any) => any): object => {
        if (this._canStore) {
            if (this._sessionStore[key] !== null && typeof this._sessionStore[key] !== "undefined") {
                if (reviver) {
                    return JSON.parse(this._sessionStore[key], reviver);
                } else {
                    return JSON.parse(this._sessionStore[key]);
                }
            }
        }
        return null;
    }

    public setArray = (key: string, value: object): void => {
        if (this._canStore) {
            this._store[key] = JSON.stringify(value);
        }
    }

    public getArray = (key: string): object => {
        if (this._canStore) {
            if (this._store[key] != null) {
                return JSON.parse(this._store[key]);
            }
        }
        return [];
    }

    public clear = (key: string): void => {
        if (this._canStore) {
            this._store.removeItem(key);
        }
    }

    public clearFromSession = (key: string): void => {
        if (this._canStore) {
            this._sessionStore.removeItem(key);
        }
    }

}

